<template>
	<div>
		
		<!-- 面包屑导航 -->
		<div class="breadcrumb f-bct  animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">当前位置：</span>
				<span class="crumb-home">快件下单</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">选择地址</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>
		
		<div class="pageFrom  animate__animated  ">
			<div class="sec-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31270_3509/24.svg')"></el-image>
				<span>选择地址</span>
			</div>
			
			<div class="shaixuanFrom f-bct">
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="consignee" :placeholder="$t('point.t2')"></el-input>
				</div>
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="mobile" :placeholder="$t('point.t3')"></el-input>
				</div>
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="address" :placeholder="$t('point.t4')"></el-input>
				</div>
				<div class="action-bar1">
					<el-button type="primary" class="submit-btn" @click="warehouselist">{{$t('point.t5')}}</el-button>
				</div>
			</div>
			
			<div class="cangList f-bct">
				<div class="info-card" @click="selIdx=index" :class="selIdx==index?'info-card-a':''" v-for="(item,index) in 2">
					<el-image class="card-icon" v-if="selIdx==index" :src="require('@/static/add2/40.png')"></el-image>
					<el-image class="card-icon" v-else :src="require('@/static/add2/39.png')"></el-image>
					<div class="card-body">
						<div class="card-name f-bct">
							<div class="name f-ct">
								<span class="t1">一号自提点</span>
								<span class="t2" v-if="index==0&&selIdx!=index">自提</span>
								<span class="t3" v-if="index==1&&selIdx!=index">送货上门</span>
							</div>
							<div class="f-ct">
								<div class="copy f-ct" @click="copyBox(item)">
									<el-image v-if="selIdx==index" :src="require('@/static/add2/43.png')"></el-image>
									<el-image v-else :src="require('@/static/add2/41.png')"></el-image>
									<span>编辑</span>
								</div>
								<div class="del f-ct" @click="copyBox(item)">
									<el-image v-if="selIdx==index" :src="require('@/static/add2/44.png')"></el-image>
									<el-image v-else :src="require('@/static/add2/42.png')"></el-image>
									<span>删除</span>
								</div>
							</div>
						</div>
						<div class="card-contact">
							<span>陈子龙</span>
							<span>13580505080</span>
						</div>
						<div class="card-addr"><span class="addr-blue">美国</span>广东省广州市学山文化创意园 b1-607</div>
					</div>
				</div>
			</div>
			
		</div>
		
		<!-- 底部按钮区 -->
		<div class="dialog-footer  animate__animated  ">
			<button class="btn-confirm" @click="link('/userPageLab/orderPageAddrMsg')">新增收件人</button>
		</div>
		
	</div>
</template>
<script>
import { warehouselist } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			consignee:'',
			mobile:'',
			address:'',
			cangMsg:[],
			selIdx:0,
		}
	},
	mounted() {
		this.warehouselist()
	},
	methods:{
		submitOrder(){
			var item = this.cangMsg[this.selIdx]
			this.$bus.$emit('cangMsgGet', item)
			this.back()
		},
		copyBox(item){
			var cangMsg = item
			var str = cangMsg.name+cangMsg.consignee+cangMsg.mobile+cangMsg.province+cangMsg.city+cangMsg.address
			this.copy_txt(str)
		},
		// 仓库列表(全部正常的)
		async warehouselist(){
			var data = {}
			if(this.bossCodeAll){
				data.bossCode = this.bossCodeAll
			}
			if(this.memberCode){
				data.memberCode = this.memberCode
			}
			const res = await warehouselist(data)
			if(res.code==200){
				this.cangMsg = res.rows
			}else{this.Tips(res.msg,'error')}
		},
	},
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #999999;
$text-muted: #C6C6C6;
$border-color: #D9D9D9;
$page-bg: #F8F8F8;
$card-bg: #FFFFFF;
$cargo-bg: #FAFCFE;
$info-bg: #FAFAFA;
$thumb-bg: #E7F6FF;
$radius-sm: 0.04rem;
$radius-md: 0.08rem;
$radius-lg: 0.12rem;

$font-lg: 0.20rem;
$font-md: 0.16rem;
$font-sm: 0.14rem;
$font-xs: 0.13rem;

$input-height: 0.50rem;
$gap-section: 0.32rem;
$gap-form: 24px;
$gap-upload: 0.14rem;
$sel-gap: 24px; // 选项间距	

/* ========== 通用区块标题 ========== */
.sec-title {
	display: flex;
	align-items: center;
	margin-bottom: 0.16rem;

	.el-image {
		width: 0.02rem;
		height: 0.20rem;
		margin-right: 0.08rem;
		// flex-shrink: 0;
		display: block;
	}

	span {
		font-size: $font-lg;
		font-weight: 500;
		color: $text-dark;
	}
}
.pageFrom{
	width: 100%;
	background: #fff;
	border-radius: 10px;
	padding: 24px 32px;
	margin-top: 24px;
	padding-bottom: 40px;
	
}
/* ========== 操作按钮区 ========== */
.action-bar {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.30rem;
	padding-top: 0.24rem;
	.submit-btn {
		width: 1.84rem;
		height: 0.60rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}
.action-bar1 {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.submit-btn {
		width: 1.16rem;
		height: 0.46rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}

/* ========== 信息卡片 ========== */
.cangList{
	
}

.info-card {
	width: 758px;
	background: #f9f9f9;
	cursor: pointer;
	border-radius: 12px;
	padding: 24px 32px;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	margin-top: 0.16rem;
	transition:  0.25s ;

	.card-icon {
		width: 0.20rem;
		height: 0.20rem;
		flex-shrink: 0;
		margin-right: 0.12rem;
		margin-top: 0.02rem;
	}

	.card-body {
		flex: 1;
		min-width: 0;
	}

	.card-name {
		font-size: $font-md;
		font-weight: 500;
		color: $text-dark;
		margin-bottom: 0.12rem;
		display: flex;
		align-items: center;
		.name{
			.t1{
				color: #333333;
				font-weight: bold;
			}
			.t2{
				background: #FFEDED;
				height: 22px;
				display: flex;
				align-items: center;
				padding: 0 12px;
				color: #FF4747;
				font-size: 14px;
				border-radius: 4px;
				margin-left: 8px;
			}
			.t3{
				background: #EDF6FF;
				height: 22px;
				display: flex;
				align-items: center;
				padding: 0 12px;
				color: #0096FF;
				font-size: 14px;
				border-radius: 4px;
				margin-left: 8px;
			}
		}
		.copy{
			span{
				font-size: 14px;
				color: #0096FF;
			}
			::v-deep .el-image{
				width: 15px;
				margin-right: 6px;
			}
		}
		.del{
			margin-left: 16px;
			span{
				font-size: 14px;
				color: #FC3C3C;
			}
			::v-deep .el-image{
				width: 15px;
				margin-right: 6px;
			}
		}
		.card-phone {
			margin-left: 0.20rem;
			font-weight: 400;
		}
	}

	.card-contact {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.08rem;

		span + span {
			margin-left: 0.16rem;
		}
	}

	.card-sub {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.06rem;
	}

	.card-addr {
		font-size: $font-sm;
		color: $text-gray;
		word-break: break-all;

		.addr-blue {
			color: $primary;
			margin-right: 0.06rem;
		}

		.addr-gray {
			color: $text-gray;
		}
	}
}
.info-card-a{
	transition:  0.25s ;
	span,div{
		color: #fff!important;
	}
	background: #0096FF;
}
.shaixuanFrom{
	margin-bottom: 12px;
	.iptBox{
		width: 445px;
		height: 50px;
		border-radius: 8px;
		background: #F9F9F9;
		padding: 0 20px;
		display: flex;
		align-items: center;
		::v-deep .el-input {
			width: 400px;
			height: 100%;
			border: none;
			padding-left: 16px;
		}
		::v-deep .el-input__inner {
			text-align: left;
			width: 100%;
			height: 100%;
			line-height: 0.78rem;
			background: transparent;
			border: none;
			font-size: 16px;
			padding: 0;
			&::placeholder {
				color: #A8A8A8;
			}
			&:focus {
				border-color: transparent;
				box-shadow: none;
			}
		}
	}
}
/* ===== 面包屑 ===== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover { color: #0096FF; }
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-top: 4px;
	margin-top: 32px;
}


/* 返回按钮 */
.btn-cancel {
	width: 184px;
	height: 60px;
	background: #E9F6FF;
	border: none;
	border-radius: 10px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}


/* 确认修改按钮 */
.btn-confirm {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border: none;
	border-radius: 10px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}
</style>